import React, { useEffect, useState } from 'react';
import { couponApi } from '../services/api';
import CouponCard from '../components/CouponCard';
import Toast from '../components/Toast';
import Newsletter from '../components/Newsletter';
import Logo from '../components/Logo';
import AdBanner from '../components/AdBanner';

function HomePage() {
  const [coupons, setCoupons] = useState([]);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ app: '', category: '' });
  const [searchQuery, setSearchQuery] = useState('');
  const [toast, setToast] = useState({ show: false, message: '', type: 'info' });

  useEffect(() => {
    fetchCoupons();
  }, [filters]);

  useEffect(() => {
    // Filter coupons based on search query
    if (searchQuery.trim() === '') {
      setFilteredCoupons(coupons);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = coupons.filter(coupon =>
        coupon.title.toLowerCase().includes(query) ||
        coupon.brandName.toLowerCase().includes(query) ||
        coupon.discountText.toLowerCase().includes(query)
      );
      setFilteredCoupons(filtered);
    }
  }, [searchQuery, coupons]);

  const showToast = (message, type = 'info') => {
    setToast({ show: true, message, type });
  };

  const fetchCoupons = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.app) params.app = filters.app;
      if (filters.category) params.category = filters.category;

      const response = await couponApi.getCoupons(params);
      setCoupons(response.data);
      setFilteredCoupons(response.data);
    } catch (error) {
      console.error('Error fetching coupons:', error);
      showToast('Failed to load coupons', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div>

      <div className="header user-header">
        <div className="container">
          <h1><Logo size={40} />Coupon Adda</h1>
          <p className="header-subtitle">Your Premium Destination for Best Deals & Discounts</p>
        </div>
      </div>

      <div className="container">
        {/* Top Ad Banner */}
        <AdBanner slot="1234567890" format="horizontal" className="ad-top" />

        <div className="filters">
          <input
            type="text"
            className="search-bar"
            placeholder="🔍 Search coupons by title, brand, or discount..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="filter-group">
            <select name="app" value={filters.app} onChange={handleFilterChange}>
              <option value="">All Apps</option>
              <option value="GPay">GPay</option>
              <option value="Paytm">Paytm</option>
              <option value="PhonePe">PhonePe</option>
              <option value="Website">Website</option>
            </select>

            <select name="category" value={filters.category} onChange={handleFilterChange}>
              <option value="">All Categories</option>
              <option value="Food">Food</option>
              <option value="Fashion">Fashion</option>
              <option value="Electronics">Electronics</option>
              <option value="Beauty">Beauty</option>
              <option value="Travel">Travel</option>
              <option value="Grocery">Grocery</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="loading-skeleton">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="skeleton-card">
                <div className="skeleton-line" style={{ width: '70%', height: '24px' }}></div>
                <div className="skeleton-line" style={{ width: '50%' }}></div>
                <div className="skeleton-line" style={{ width: '90%' }}></div>
                <div className="skeleton-line" style={{ width: '60%' }}></div>
              </div>
            ))}
          </div>
        ) : filteredCoupons.length === 0 ? (
          <div className="empty-state">
            <h2>😔 No coupons found</h2>
            <p>{searchQuery ? 'Try adjusting your search' : 'Check back later for new deals!'}</p>
          </div>
        ) : (
          <>
            <div className="main-content-full">
              <div style={{ color: '#2c3e50', marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>
                {filteredCoupons.length} {filteredCoupons.length === 1 ? 'coupon' : 'coupons'} available
              </div>
              <div className="coupon-grid">
                {filteredCoupons.map((coupon, index) => (
                  <React.Fragment key={coupon.id}>
                    <CouponCard coupon={coupon} onCopy={showToast} />
                    {/* Insert ad after every 3 coupons */}
                    {(index + 1) % 3 === 0 && index < filteredCoupons.length - 1 && (
                      <div style={{ gridColumn: '1 / -1' }}>
                        <AdBanner slot="9876543210" format="horizontal" />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </>
        )}

        {/* Bottom Ad Banner */}
        <AdBanner slot="1357924680" format="horizontal" className="ad-bottom" />

        {/* Newsletter Signup */}
        <Newsletter />
      </div>
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Coupon Adda</h4>
            <p>Your trusted source for verified coupons and deals</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/how-it-works">How It Works</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms-of-service">Terms of Service</a></li>
              <li><a href="/disclaimer">Disclaimer</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Coupon Adda. All rights reserved.</p>
        </div>
      </footer>

      {toast.show && (
        <Toast 
          message={toast.message} 
          type={toast.type} 
          onClose={() => setToast({ show: false, message: '', type: 'info' })} 
        />
      )}
    </div>
  );
}

export default HomePage;
